import { useReducer } from 'react'
import { INIT_FORM, RESET_FORM } from '../constants'
import { AtrributePhoto, InitialData, InitialForm, SetCageSelection } from '../types'
import { getDateTime } from '../../../helpers/getDateTime'
import { formReducer } from '../formReducer'

export const useDataForm = () => {
  const [form, setForm] = useReducer(formReducer, INIT_FORM)

  const handleCenter = (data: InitialData[]) => {
    setForm({
      type: 'handleCenter',
      payload: {
        centerId: data[0]?.id_centro ?? null,
        centerName: data[0]?.nombre ?? null,
      },
    })
  }

  const setInitialForm = (values: InitialForm) => {
    setForm({
      type: 'setInitialForm',
      payload: values,
    })
  }

  const setCageSelection = (payload: SetCageSelection) => {
    setForm({
      type: 'setCageSelection',
      payload,
    })
  }

  const setSinglePhoto = (attribute: AtrributePhoto, photo: { uri: string }) => {
    setForm({
      type: 'setSinglePhoto',
      payload: {
        attribute,
        photo: {
          uri: photo.uri,
          dateTime: { ...getDateTime() },
        },
      },
    })
  }

  const setAditionalPhoto = (photo: { uri: string }) => {
    setForm({
      type: 'setAdditionalPhoto',
      payload: {
        tempId: new Date().getTime(),
        photo: {
          uri: photo.uri,
          dateTime: { ...getDateTime() },
        },
      },
    })
  }

  const removeAditionalPhoto = (tempId: string) => {
    setForm({
      type: 'removeAdditionalPhoto',
      tempId,
    })
  }

  const handleFinalForm = (comments: string) => {
    setForm({
      type: 'finalForm',
      comments,
    })
  }

  const resetForm = () => {
    setForm({
      type: 'resetData',
      payload: RESET_FORM,
    })
  }

  return {
    form,
    setInitialForm,
    setCageSelection,
    setSinglePhoto,
    setAditionalPhoto,
    resetForm,
    handleFinalForm,
    removeAditionalPhoto,
    handleCenter,
  }
}
